import { getDocumentDisplayParts } from '@utils/documentUtils';
import type { SearchResult } from './searchResults';

/**
 * Maps the API's search results onto the card's shape. Several fields are
 * load-bearing rather than decorative: pageNumber and segmentId drive
 * click-through to the highlighted passage, citationIndex ties a row to the
 * [n] marker in the answer, and the workbook/table identifiers are how
 * spreadsheet evidence is located.
 */
export function mapApiResultsToCards(results: any[]): SearchResult[] {
  return results.map((r) => {
    if (r.type === 'web') {
      return {
        id: r.id,
        title: r.title || '',
        path: r.sourceUrl ? [r.sourceUrl] : [],
        type: 'web' as const,
        snippet: r.snippet || '',
        excerpt: r.excerpt || r.snippet || '',
        relevance: r.relevanceScore || 0.5,
        relevanceLabel: r.relevanceLabel,
        rawRelevance: r.rawRelevanceScore,
        relevanceSource: r.relevanceSource,
        citationIndex: r.citationIndex,
        selected: r.selected,
        sourceUrl: r.sourceUrl,
        provider: r.provider,
      };
    }

    // Avoids "spec.pdf / spec.pdf" when the title is already the file name.
    const displayParts = getDocumentDisplayParts(r.title, r.fileName);

    return {
      id: r.id,
      title: displayParts.main || '',
      path: displayParts.subtitle ? [displayParts.subtitle] : [],
      type: 'document' as const,
      snippet: r.snippet || '',
      excerpt: r.excerpt || r.snippet || '',
      relevance: r.relevanceScore || 0.5,
      relevanceLabel: r.relevanceLabel,
      rawRelevance: r.rawRelevanceScore,
      relevanceSource: r.relevanceSource,
      citationIndex: r.citationIndex,
      selected: r.selected,
      pageNumber: r.pageNumber,
      segmentId: r.segmentId,
      aggregation: r.aggregation,
      coverageStatus: r.coverageStatus,
      coverageReasons: r.coverageReasons,
      sheetName: r.sheetName,
      cellRef: r.cellRef,
      cellRange: r.cellRange,
      xlsxAnchor: r.xlsxAnchor,
      tableBlockId: r.tableBlockId,
      tableFactId: r.tableFactId,
      tableTitle: r.tableTitle,
      rowKey: r.rowKey,
      columnHeader: r.columnHeader,
      valueText: r.valueText,
      unit: r.unit,
    };
  }) as SearchResult[];
}
